import type { Customer, FreightType } from "../../model/customer.model";

export type FreightPolicy = {
  locked: boolean;
  allowed: FreightType[];
  reason?: string;
};

const FILIAL_DEFAULT_C001 = "C001";
const CDM_FILIALS = new Set(["CDM1", "CDM2"]);

export function getFreightPolicy(args: {
  customer?: Customer;
  selectedFilialId?: string;
}): FreightPolicy {
  const { customer, selectedFilialId } = args;

  if (!customer) {
    return {
      locked: true,
      allowed: ["CIF", "FOB"],
      reason: "Selecione um cliente.",
    };
  }

  // regra: CDM -> somente FOB
  if (selectedFilialId && CDM_FILIALS.has(selectedFilialId)) {
    return {
      locked: true,
      allowed: ["FOB"],
      reason: "Filial CDM permite apenas FOB.",
    };
  }

  // regra: trava se existir filial default C001 em algum endereço
  const lockDefaultFreightType =
    customer.addresses?.some(
      (a) => a.filialIdDefault === FILIAL_DEFAULT_C001
    ) ?? false;

  if (lockDefaultFreightType) {
    return {
      locked: true,
      allowed: [customer.freightType],
      reason: "Frete travado pela filial padrao C001.",
    };
  }

  return { locked: false, allowed: ["CIF", "FOB"] };
}

export function toFreightSafe(v: string): FreightType {
  return v === "CIF" || v === "FOB" ? v : "CIF";
}
